
import { FaInstagram } from 'react-icons/fa';
import { useState, useEffect } from 'react';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import { useVenueName } from '../hooks/useVenueName';
function Footer({panel, onResetCookies}) {
  const { name, loading } = useVenueName();
      const [contact, setContact] = useState(null);

  useEffect(() => {
    if (!name) return;

    const fetchContact = async () => {
      const ref = doc(db, "venues", name, "pages", "kontakt");
      const snap = await getDoc(ref);

      if (!snap.exists()) return;

      const contactSection = snap
        .data()
        .sections?.find(sec => sec.type === "contact");

      setContact(contactSection || null);
    };

    fetchContact();
  }, [name]);
  if (loading){
    return
  }

return (
  
<footer className="p-6 bg-[#f4f4f4] text-gray-700">
  <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between gap-10">

  {/* Kontakt */}
    <div className="flex-1">
      <h2 className="font-bold text-lg mb-2 text-black">Kontakt</h2>
          {contact?.phone && (
            <p className="text-sm font-bold mt-2">
              Telefon:
              <a
                href={`tel:${contact.phone}`}
                className="ml-1 text-blue-600 hover:underline"
              >
                {contact.phone}
              </a>
            </p>
          )}
          {contact?.instagram && (
            <p className="flex items-center gap-2 mt-2 text-sm">
              <span className="font-bold">Instagram:</span>
              <a
                href={contact.instagram}
                className="text-pink-600 hover:underline flex items-center gap-1 font-semibold"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram className="text-xl" />
                @{contact.instagram.replace("https://www.instagram.com/", "").replace("/", "")}
              </a>
            </p>
          )}
      <div className='gap-2 flex items-center'>
        <button
            onClick={onResetCookies}
            className="mt-3 px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded-lg text-sm"
        >
            Zmień zgodę na pliki cookies
        </button>
      </div>
    </div>

    {/* Prawa autorskie */}
    <div className="flex-1 text-sm">
      <p className="font-bold">© Maciej Głąb 2025</p>
      <p>
        Design and project by{" "}
        <a
          target="_blank"
          rel='noreferrer'
          className="underline"
          href="https://maciejglab.pl"
        >
          Maciejka
        </a>
      </p>
    </div>
  </div>
</footer>

);
}
export default Footer